import type { ParameterFields } from './parameter-types';

/** 冻结的历史兼容预设；新业务字段应登记到宿主 configured 配置。 */
export const LEGACY_FIELDS: ParameterFields = {
  _merCode: {}, _userId: {}, _memberId: {}, _memberEmpCode: {}, _memberEmpStCode: {},
  _proCode: { aliases: ['productId'] }, _specId: { aliases: ['specId'] }, _storeCode: { aliases: ['storeId'] },
  _keyword: { aliases: ['keyword'] }, _orderNo: {}, _orderId: { aliases: ['orderId'] },
  _fromSite: { aliases: ['fromSite'] }, _trackId: {}, _uuid: {}, _ref: { aliases: ['referrer'] },
  _currentURL: { aliases: ['currPage', 'pageUrl', 'pagePath'] },
  _is_new_visit: {}, _platform: {}, _sessionId: {}, _uuidMdKey: {}, _shopCart: {},
  _longitude: {}, _latitude: {}, _action: { aliases: ['action'] }, _actionType: { aliases: ['actionType'] },
  _activityId: { aliases: ['activityId'] }, _prePageDuration: {}, _fromChannel: {}, _fromMedia: {},
  _empCode: { aliases: ['empCode'] }, _addCartUUID: {}, _timeStamp: {},
  _attr8: { aliases: ['smsType'] }, _attr9: { aliases: ['msgSpId'] },
};
